import React from 'react';

const Worlds = () => {

   return (
      <section className="feature">
           <div className="feature-description">
               <h1>2019 World Championships - Silver Medalist</h1>
               <ul>
                  <li>First event held in the Olympic Gymnastics Stadium, built specifically for the 2020 Olympics. <br></br> (The structure will be demolished after the Olympic Games)</li>
                  <li>First time competing in World Championships</li>
                  <li>Competed against World Champions and Olympic Medalists</li>
                  <li>This event qualified the US into the 2021 World Games</li>
               </ul>
            </div>

      </section>
   )
}

export default Worlds;